import { api } from "../App";
import {createNotification} from "../components/Notifications/Notifications";
import {
    GET_EXAM_CITY_LIST,
    SET_EXAM_CITY_LIST_LOADING,
    SET_EXAM_CITY_BY_ID
} from "./types";

export const getExamCityList = () => async(dispatch, getState) => {
    try {
        dispatch({type: SET_EXAM_CITY_LIST_LOADING, payload: true});
        const { data } = await api.get(`/exam_city`);
        dispatch({type: GET_EXAM_CITY_LIST, payload: data});
    } catch (error) {
        console.error('Error in exam_city action:', error);
        dispatch({type: GET_EXAM_CITY_LIST, payload: []});
    } finally {
        dispatch({type: SET_EXAM_CITY_LIST_LOADING, payload: false});
    }
};

export const updateExamCity = (params) => async(dispatch, getState) => {
    try {
        await api.put(`/exam_city/${params.xp_key}`, params);
        await dispatch(getExamCityList());
        createNotification('success', 'Успешно!');
    } catch (error) {
        console.error('Error in exam_city action:', error);
    }
}

export const createExamCity = (data, addMode) => async(dispatch, getState) => {
    try {
        const { data: result } = await api.post(`/exam_city`, data);
        createNotification('success', 'Успешно');
        await dispatch(getExamCityList());
        if (addMode) {
            const newId = result.xp_key;
            await dispatch(getExamCityItem(newId));
        }
    } catch (error) {
        console.error('Error in exam_city action:', error);
        createNotification('error', "Не удалось создать запись");
    }
};

export const deleteExamCity = (id) => async(dispatch, getState) => {
    try {
        await api.delete(`/exam_city/${id}`);
        createNotification('success', 'Успешно');
        await dispatch(getExamCityList());
    } catch (error) {
        console.error('Error in exam_city action:', error);
        createNotification('error', error.message || 'Произошла ошибка');
    }
};

export const updateExamCityAddress = (city_id, params) => async(dispatch, getState) => {
    try {
        await api.put(`/exam_city/address/${params.id}`, params);
        await dispatch(getExamCityItem(city_id));
        createNotification('success', 'Успешно!');
    } catch (error) {
        console.error('Error in exam_city action:', error);
    }
}

export const createExamCityAddress = (city_id, data) => async(dispatch, getState) => {
    try {
        await api.post(`/exam_city/${city_id}/address`, data);
        createNotification('success', 'Успешно');
        await dispatch(getExamCityItem(city_id));
    } catch (error) {
        console.error('Error in exam_city action:', error);
        createNotification('error', "Не удалось создать запись");
    }
};

export const deleteExamCityAddress = (id, city_id) => async(dispatch, getState) => {
    try {
        await api.delete(`/exam_city/address/${id}`);
        createNotification('success', 'Успешно');
        await dispatch(getExamCityItem(city_id));
    } catch (error) {
        console.error('Error in exam_city action:', error);
        createNotification('error', error.message || 'Произошла ошибка');
    }
};

export const getExamCityItem = (id) => async (dispatch, getState) => {
  try {
    const { data } = await api.get(`/exam_city/${id} `);
    dispatch({ type: SET_EXAM_CITY_BY_ID, payload: data });
  } catch (error) {
    console.error('Error in exam_city action:', error);
  }
};